<template>
   <div class="page__content">

      <race-details-component :details="race.details" :result="result"></race-details-component>

      <div class="page__container">

         <div class="col-layout col-layout--sidebar">
            <div class="col-layout__row">
               <div class="col-layout__item">

                  <section class="block block--medium">
                     <div class="block__header block__header--primary" v-if="race.details.bets && race.details.bets.length > 0">
                        <h3 class="block__title" v-if="isResult">
									<span class="block__title__icon">
										<t tag="result.title.report"/>
									</span>
                           <span class="float-right">
										<t tag="result.title.report.amount"/>
									</span>
                        </h3>
                     </div>
                     <!--     -->
                     <div class="block__content block__content--bordered" v-if="race.details.bets && race.details.bets.length > 0">
                        <div class="row">
                           <div class="col-12">
                              <ul class="games__list">
                                 <!-- BET TYPES -->
                                 <li class="games__list__item"
                                     :key="bet.id"
                                     v-for="bet in sortBettype(race.details.bets)"
                                     :class="{'is-active': selectedBetType && (bet.code === selectedBetType.code) }">
                                    <game
                                        class="pointer"
                                        iconed
                                        :bet="bet"
                                        @click.native="selectedBetType = bet"
                                    />
                                 </li>

                              </ul><!-- /.games__list -->
                           </div>
                        </div>

                     </div>
                     <div class="block__content" v-if="race.details.pmujackpot">
                        <div class="row result__features">
                           <div class="col-12 col-lg-6">
										<span title="Quinte+" class="game games__list__link pointer game--iconed game--quinte">
												Quinte+
											</span>


                           </div>
                           <div class="col-12 col-lg-6 result__features__boost">
                              <div class="tirelire">
                                 Jackpot du {{ formatToDate(race.details.time, 'DD/MM/YYYY') }}
                                 <span class="number">{{ formatToMoney(race.details.pmujackpot*100) }}</span>
                              </div>
                              <!--<div class="boost">
                                 Boost Ordre du Quinté + 100 000 000€
                              </div>-->
                           </div>
                        </div>
                     </div>
                  </section>
                  <section class="block block--medium block--nopad" v-if="isResult && resultByType.length">
                     <div class="block__content">
                        <div class="row">
                           <div class="col-12">
                              <!-- RESULT table -->
                              <table class="table__result" v-if="resultByType.length">
                                 <tbody>
                                    <tr>
                                       <th>{{t('result.table.arrival')}}</th>

                                       <th>
                                          {{t('result.table.type')}}
                                       </th>
                                       <th>
                                          {{selectedBetType.title}}
                                       </th><!--
												<th>PLACE
													<br> Rapport </th>-->
                                    </tr>
                                    <tr v-for="(res, index) in resultByType" :key="'result-'+snakeCase(res.pool)+'-'+index">
                                       <td class="boldNum"> {{ res.combination }}

                                       </td>
                                       <td>
                                          {{t(res.type)}}
                                       </td>
                                       <td>{{ formatToMoney(res.odd) }}</td>
                                       <!--<td>1 </td>-->
                                    </tr>
                                 </tbody>
                              </table>

                              <!-- NO RESULT -->
                              <table class="table__result" v-if="resultByType.length === 0 && selectedBetType !== ''">
                                 <tbody>
                                    <tr>
                                       <th>{{t('result.table.arrival')}}</th>

                                       <th>
                                          {{t('result.table.type')}}
                                       </th>
                                       <th>
                                          {{selectedBetType.title}}
                                       </th>
                                    </tr>
                                    <tr>
                                       <td colspan="3">
                                          {{t('result.table.noresult')}}
                                       </td>
                                    </tr>
                                 </tbody>
                              </table>

                           </div>
                        </div>
                     </div>
                  </section>



                  <section class="block block--medium block--nopad">
                     <div class="block__header block__header--primary">
                        <h3 class="block__title">
									<span class="block__title__icon" v-if="isResult">
										<t tag="result.title.runners"/>
									</span>
                        </h3>
                     </div>
                     <div class="block__content">


                        <table class="table__bet">
                           <thead>
                              <tr class="table__bet__header ">
                                 <th class="text-center" v-if="isResult"><span class="">Place</span></th>
                                 <th><span class="visually-hidden">Casaque</span></th>
                                 <th><span class="visually-hidden">Numéro</span></th>
                                 <th class="table__bet__header__info"><span class="visually-hidden">Infos</span></th>
                                 <th class="table__bet__header__horse">Cheval</th>
                                 <th class="table__bet__header__driver">Jockey</th>
                                 <th class="table__bet__header__music">Musique</th>
                                 <th class="table__bet__header__distance">{{ race.details.type === 'H' ? 'Red. Km' : 'Ecart préct' }}</th>
                                 <th class="table__bet__header__rate">Cote</th>
                              </tr>
                           </thead>
                           <tbody class="table__bet__row"
                               v-if="runner.startnr<101"
                               :class="{ 'table__bet__row--pp-open': runnerDetails === runner.id }"
                               v-for="runner in sortedRunners"
                               :key="runner.startnr">
                              <tr  :class="{ 'is-disabled': !runner.status }">
                                 <td class="table__bet__place" v-if="isResult">
												<span v-if="runner.finishorder">
													{{ runner.finishorder }}
												</span>
                                 </td>
                                 <td class="table__bet__cassock">
                                    <img :src="silkPath(runner.jockeycolorfile)" :alt="runner.jockeycolour">
                                 </td>
                                 <td class="table__bet__number">
                                    {{ runner.prognr }}
                                 </td>
                                 <td class="table__bet__info">
                                    <a :id="'table__bet__info__runner--'+runner.id" class="pointer" @click="horseInfo(runner)" aria-haspopup="true">
                                       <span class="icon icon--info" aria-hidden="true"></span>
                                    </a>
                                 </td>
                                 <td class="table__bet__horse">
													<span class="pointer" :title="runner.horse.name" v-if="runner.horse" @click="toggleDetails(runner.id)">
														{{ runner.horse.name }}
													</span>
                                 </td>

                                 <!-- ACTIVE runner -->
                                 <td class="table__bet__driver">
													<span v-if="runner.status && runner.rider">
														{{ runner.rider.name }}
													</span>
                                 </td>
                                 <td class="table__bet__music" :title="musiqueParser(runner.shortperformance).toLowerCase()">
                                    <span v-if="runner.status">{{ musiqueParser(runner.shortperformance) }}</span>
                                 </td>
                                 <td class="table__bet__distance pr-3 pl-2">
                                    {{runner.finishtext}}
                                 </td>

                                 <td class="table__bet__rate" v-if="runner.status">
                                    <span v-if="runner.odd">{{ runner.odd /100 }}</span>
                                 </td>

                                 <!-- NOT-activerunner -->
                                 <!--											<td v-else-if="!runner.status && !isMobile"></td>-->
                                 <td v-else-if="!runner.status"><b>NON PARTANT</b></td>
                              </tr>
                              <tr v-if="runnerDetails == runner.id">
                                 <td colspan="9">
                                    <runner-details :runner="runner"></runner-details>
                                 </td>
                              </tr>
                           </tbody>
                        </table><!-- /.table__bet -->


                     </div>
                  </section>

               </div>
               <aside class="col-layout__item col-layout__item--sidebar">


                  <next-races></next-races>
                  <sidebar-banners></sidebar-banners>
                  <!-- /.departure -->

               </aside><!-- /.col-layout__item.col-layout__item--sidebar -->
            </div>
         </div><!-- /.col-layout.col-layout--sidebar -->
      </div>
      <!--<vue-modaltor :visible="horsePopup.open" @hide="hideHorseInfo" class="vue-modaltor_custom" :defaultWidth="'570px'">

      </vue-modaltor>-->
      <horse-popup v-if="horsePopup" :runner="horsePopup" @hide="hideHorseInfo"></horse-popup>

   </div><!-- /.page__content -->

</template>
<script>
import Vuex from 'vuex';
import HorsePopup from '@/components/parts/HorsePopup.vue';
import NextRaces from '@/components/parts/NextRaces.vue';
import RaceDetails from '@/components/race/RaceDetails.vue';
import RunnerDetails from '@/components/race/betslip/components/RunnerDetails';


export default {
   name: 'Result',
   props: [
      'race'
   ],
   components: {
      'horse-popup': HorsePopup,
      'race-details-component': RaceDetails,
      'next-races': NextRaces,
      'runner-details': RunnerDetails,
      'sidebar-banners': () => import('@/components/parts/sidebar-banners') //lazy load
   },
   data() {
      return {
         horsePopup: null,
         selectedBetType: '',
         runnerDetails: null
      }
   },
   computed: {
      ...Vuex.mapState([
         'lang'
      ]),
      isResult(){
         return  this.race.details && (this.race.details.status === 'OFFICIAL' || this.race.details.status === 'FINISHED');
      },
      sortedRunners() {
         if (this.isResult && this.race.details.runners) {
            return this.race.details.runners.slice().sort((a, b) => {

               if (a.finishorder === null && b.finishorder === null) {
                  return 0;
               } else if (a.finishorder === null) {
                  return 1;
               } else if (b.finishorder === null) {
                  return -1;
               }
               return a.finishorder - b.finishorder;
            }).sort((a, b) => {


               if(!a.status){
                  return 1;
               }else if(!b.status){
                  return -1;
               }
               return 0;
            })
         } else {
            return this.race.details.runners;
         }
      },
      resultCombination(){

         let combination = [];

         if(this.race.meeting.races[0] && this.race.meeting.races[0].result){
            combination = this.race.meeting.races[0].result.split(' - ');

         }

         /*this.sortedRunners.forEach((el)=>{
            if(el.finishorder !== null){
               combination.push(el.prognr);
            }
         });*/
         return combination;
      },
      result(){

         let r = {
            combination: this.resultCombination,
            time: ''
         };

         if(r.combination.length === 0){
            return null;
         }

         return r;
      },
      resultByType(){

         let result = this.race.details.dividends.slice();
         result = result.filter((el)=> el.pool === this.selectedBetType.code );

         var isComplexByOdd = result.every( el =>{
            //validate if result combination is complex like: "14 - 11" or "2 - NP - NP" e.t.c.
            return /[^\d]+/.test(el.combination);
         });

         let comb = this.resultCombination.slice();



         if(this.selectedBetType && this.selectedBetType.code){


            return result.sort((a, b)=> {

               //Combination is complex, use sort by odd
               if(isComplexByOdd || comb.length === 0){

                  return b.odd - a.odd;
               }else{


                  let aIndex = comb.indexOf(a.combination);
                  let bIndex = comb.indexOf(b.combination);

                  if(aIndex >= 0 && bIndex >= 0){
                     return aIndex - bIndex;
                  }else if(aIndex === -1 && bIndex === -1){
                     return 0;
                  }else if(bIndex >= 0 ){

                     return 1;
                  }

                  return -1;


               }

            });
         }else{
            return result;
         }
      }
   },
   watch: {
      /*'$route'(to, from) {
         // обработка изменений параметров пути...
      }*/
   },
   mounted() {

   },
   methods: {
      horseInfo(runner) {
         this.horsePopup = runner;
      },
      hideHorseInfo() {
         this.horsePopup = null;
      },
      betClasses(bet) {
         let clss = [];

         clss.push('game--' + this.snakeCase(bet.code));

         //Check if active
         if (this.selectedBetType && (bet.code === this.selectedBetType.code)) {
            clss.push('is-active');
         }

         return clss;
      },
      toggleDetails(id){
         if(this.runnerDetails !== id && !this.isMobile){
            this.runnerDetails = id;
         }else{
            this.runnerDetails = null;
         }
      },
   }
}
</script>
<style lang="scss">


</style>
